module.exports = __webpack_public_path__ + "static/media/expBlue.7357a5e8.svg";